import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import CloseIcon from '@material-ui/icons/Close';
import MUIIconButton from '@material-ui/core/IconButton';

const MUIIconButtonWrapper = styled(MUIIconButton)`
  & .MuiSvgIcon-root {
    font-size: 64px;
  }
`;

const LargeCloseButton = ({ onClick }) => (
  <MUIIconButtonWrapper onClick={onClick}>
    <CloseIcon />
  </MUIIconButtonWrapper>
);

LargeCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LargeCloseButton;
